<template>
  <div ref="REMUNERATION" class="section">
    <section-header ref="REMUNERATION"
                    :dialog="dialog"
                    :ressource="ressource"
                    :is-extended="extended"
                    @extended=setExtended
                    @close-dialog="closeDialog">
    </section-header>

    <v-row v-if="extended">
      <v-col class="col-12">
        <div v-if="canEdit">
          <div class="ps-md-4 pt-3">
            <v-row v-if="!editPaie">
              <v-col class="col-md-3 col-12 py-0">
                <div class="select-field py-3">
                  <v-select ref="COMBO_BOX"
                            v-model=calculMode
                            class="'edit-field'"
                            :items=listModes
                            :label=labelModes
                            :placeholder="placeholder"
                            :persistent-placeholder="placeholder!=''"
                            :outlined="false"
                            :ripple="false"
                            dense>
                  </v-select>
                </div>
              </v-col>
              <v-col v-if="calculTaux" class="col-md-6 col-12 ps-0 py-0">
                <v-row v-for="(item, index) in rubriquesBrut" :key="item.id" class="m-0">
                  <v-col class="col-5 py-0">
                    <edit-currency :context-id="contratId"
                                   :hide-label="index > 0"
                                   :libelle=montantLabel
                                   :value="rubriqueBaseFixed(item.id)"
                                   @update:value="(value) => setRubriqueBase(value, item.id)">
                    </edit-currency>
                  </v-col>

                  <v-col class="col-7  py-0">
                    <edit-info :context-id="contratId"
                               :hide-label="index > 0"
                               :value="minimum(item.id)"
                               :libelle=minimumLabel
                               :read-only="true">
                    </edit-info>
                  </v-col>

                </v-row>
              </v-col>
              <v-col v-if="!calculTaux && contrat.modeCalcul > 0" class="col-md-3 col-12 py-0">
                <edit-currency ref="MONTANT"
                               :context-id="contratId"
                               :value="montant"
                               :libelle=montantLabel
                               :required=true
                               @status="statusMontant"
                               @update:value="(value) => setMontant(value)">
                </edit-currency>
              </v-col>
              <v-col class="d-flex flex-row-reverse mt-2 align-self-center">
                <loader-button :disabled="calculDisabled"
                               :loading="isCalculating"
                               :label="calculLabel"
                               type="button"
                               @callback="calculate">
                </loader-button>
              </v-col>
            </v-row>

            <v-row class="pt-3">
              <v-col class="col-md-3 col-12 py-0">
                <select-field ref="RUBRIQUE_PAIE_SELECT"
                              :value="getDisplayVariable(selectedVariableId)"
                              :items=rubriquesPaie
                              :edit-field-info=selectEditFieldInfo
                              @updated="(value) => setUpdatedVariable(value)">
                </select-field>
              </v-col>
              <v-col class="col-6 px-0 py-0">
                <v-row class="m-0">
                  <v-col class="col-md-5 col-12 py-0">
                    <div v-if="isVariableNombre(selectedVariableId)">
                      <edit-quantity :context-id="contratId" :value="quantite" @update:value="setQuantite"></edit-quantity>
                    </div>
                    <div v-else-if="isVariableMontant(selectedVariableId)">
                      <edit-currency :context-id="contratId" :value="quantite" @update:value="setQuantite"></edit-currency>
                    </div>
                    <div v-else-if="isVariableDate(selectedVariableId)">
                      <date-field-multiple :edit-field-info="dateEditFieldInfo"
                                           :value="dates"
                                           :periods="[periode]"
                                           @updated="setDate">
                      </date-field-multiple>
                    </div>
                  </v-col>
                  <v-col v-if="!editPaie && selectedVariableId" class="col-md-7 col-12 py-0 align-self-center">
                    <v-checkbox v-model="showOnContract"
                                label="Faire figurer au contrat"
                                hide-details>
                    </v-checkbox>
                  </v-col>
                  <v-col v-if="selectedVariableId && listPeriods.length > 1" class="col-md-7 col-12 py-0">
                    <div class="select-field py-3">
                      <v-select ref="COMBO_BOX"
                                v-model=periodSelected
                                class="'edit-field'"
                                :items="listPeriods"
                                :label=choixPeriod
                                :placeholder="placeholder"
                                :persistent-placeholder="placeholder!=''"
                                :outlined="false"
                                :ripple="false"
                                dense>
                      </v-select>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="d-flex flex-row-reverse mt-2">
                <div v-if="editPaie" class="ms-5">
                  <loader-button :disabled="calculDisabled"
                                 :loading="isCalculating"
                                 :label="calculLabel"
                                 type="button"
                                 @callback="calculate">
                  </loader-button>
                </div>
                <loader-button :label="addUpdateLabel"
                               :outlined="true"
                               :disabled="!variableDefined"
                               @callback="addUpdateVariablePaie">
                </loader-button>
              </v-col>
            </v-row>
          </div>

          <div class="data-table-seperator py-1"></div>
        </div>

        <v-col class="col-12 p-0 ">
          <v-table class="remuneration-table" dense>
            <thead class="pb-1">
              <tr class="font-weight-bold">
                <td rowspan="2"
                    style="vertical-align: bottom; font-size: 14px; border-bottom: thin solid rgba(0, 0, 0, 0.12);">
                  {{ RessourceLabel }}
                </td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-right pt-4" style="font-size: 14px; border-bottom: thin solid rgba(0, 0, 0, 0.12);"
                    width="15%">
                  {{ RessourceQuantite }}
                </td>
                <td class="text-right pt-4" style="font-size: 14px; border-bottom: thin solid rgba(0, 0, 0, 0.12);"
                    width="15%">
                  {{ RessourceBase }}
                </td>
                <td class="text-right pt-4" style="font-size: 14px; border-bottom: thin solid rgba(0, 0, 0, 0.12);"
                    wid5th="15%">
                  {{ RessourceMontant }}
                </td>
                <td width="2%"></td>
              </tr>
            </thead>
            <tbody @click="unselectVariable()">
              <tr v-for="item in rubriquesBrut" :key="item.id">
                <td>{{ getRubriqueLabel(item.id) }}</td>
                <td class="edit-field text-right">
                  {{ quantity(rubriqueQuantity(item.id), item.id) }}
                </td>
                <td class="edit-field text-right">
                  {{ currency(rubriqueBaseFixed(item.id)) }}
                </td>
                <td class="text-right">
                  {{ currency(rubriqueMontant(item.id)) }}
                </td>
              </tr>
              <tr v-for="item in variablesBrut" :key="item.id" @click="selectVariable(item)">
                <td>
                  <v-row class="ma-0">
                    <v-col cols="4" class="pl-0">
                    {{ getVariableLabel(item) }}
                    </v-col>
                    <v-col class="py-0"  v-if="!editPaie" @click.stop>
                      <v-checkbox :model-value="!!item.showOnContract"
                                  :disabled="!canEdit || !canDelete(item)"
                                  label="Faire figurer au contrat"
                                  hide-details
                                  @update:model-value="(value) => setVariableShowOnContract(item, value)">
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </td>
                <td class="edit-field text-right"></td>
                <td class="edit-field text-right"></td>
                <td class="text-right">
                  {{ currency(variableMontant(item)) }}
                </td>
                <td class="text-right">
                  <v-icon v-if="canDelete(item)" size="25px" @click="deleteVariable(item)">fas fa-trash-can</v-icon>
                </td>
              </tr>

              <tr class="font-weight-bold">
                <td class="synthese">{{ RessourceSalaireBrut }}</td>
                <td class="text-right synthese"></td>
                <td class="text-right synthese"></td>
                <td class="text-right synthese">{{ currency(parseFloat(editBrut)) }}</td>
              </tr>

              <tr>
                <td>{{ RessourceCotisationSalariale }}</td>
                <td class="text-right"></td>
                <td class="text-right"></td>
                <td class="text-right">{{ chargeSalariale }}</td>
              </tr>
              <tr v-if="pasAPayer()">
                <td>{{ RessourcePrelevementSource }}</td>
                <td class="text-right"></td>
                <td class="text-right"></td>
                <td class="text-right">{{ currency(pasMontant()) }}</td>
              </tr>
              <tr v-for="item in variablesNet" :key="item.id" @click="selectVariable(item)">
                <td>
                  <v-row class="ma-0">
                    <v-col cols="4" class="pl-0">
                      {{ getVariableLabel(item) }}
                    </v-col>
                    <v-col class="py-0" v-if="!editPaie" @click.stop>
                      <v-checkbox :model-value="!!item.showOnContract"
                                  :disabled="!canEdit || !canDelete(item)"
                                  label="Faire figurer au contrat"
                                  hide-details
                                  @update:model-value="(value) => setVariableShowOnContract(item, value)">
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </td>
                <td class="edit-field text-right"></td>
                <td class="text-right"></td>
                <td class="text-right">
                  {{ currency(variableMontant(item)) }}
                </td>
                <td class="text-right">
                  <v-icon v-if="canDelete(item)" size="25px" @click="deleteVariable(item)">fas fa-trash-can</v-icon>
                </td>
              </tr>
              <tr class="font-weight-bold">
                <td class="synthese">{{ RessourceSalaireNetAPayer }}</td>
                <td class="text-right synthese"></td>
                <td class="text-right synthese"></td>
                <td class="text-right synthese">{{ currency(netAPayer) }}</td>
              </tr>
              <tr>
                <td>{{ RessourceCotisationPatronale }}</td>
                <td class="text-right"></td>
                <td class="text-right"></td>
                <td class="text-right">{{ chargePatronales }}</td>
              </tr>

              <tr class="font-weight-bold">
                <td class="synthese">{{ RessourceCoutEmployeur }}</td>
                <td class="text-right synthese"></td>
                <td class="text-right synthese"></td>
                <td class="text-right synthese">{{ currency(parseFloat(editEmployeur)) }}</td>
              </tr>
              <tr v-if="!editPaie">
                <td>{{ fraisGestionLabel }}</td>
                <td class="text-right"></td>
                <td class="text-right"></td>
                <td class="text-right">{{ fraisGestion }}</td>
              </tr>
              <tr v-if="!editPaie" class="font-weight-bold">
                <td class="synthese">{{ RessourceAPayer }}</td>
                <td class="text-right synthese"></td>
                <td class="text-right synthese"></td>
                <td class="text-right synthese">{{ coutTotal }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-col>
      </v-col>
    </v-row>
    <div v-if="canotModify" class="d-flex flex-row-reverse">
      <loader-button :loading="loading"
                     :outlined=true
                     :label="modifyContrat"
                     class="mt-2 ms-2"
                     type="button"
                     @callback="modify">
      </loader-button>
    </div>
  </div>
</template>

<script lang="ts">
  import { isMobile } from "@/style/StyleHelpers";
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import { EditFieldType, FieldInfo } from '@/framework/base/components/FieldInfo';
  import Item from '@/framework/base/classes/Item';
  import Contrat, { ContratModeCalculs, ContratStatuts } from '@/generated/classes/Contrat';
  import Paie, { PaieStatuts } from '@/generated/classes/Paie';
  import { DateFormat, Period } from '@/framework/base/helpers/DateFormat';
  import { storeEtablissement, storePaie, storeRubrique } from '@/generated/stores';
  import Rubrique, {
    BaseSalarie,
    RubriqueCategorys,
    RubriquePaie,
    RubriqueTypes,
    VariablePaie
  } from '@/generated/classes/Rubrique';
  import EditCurrency from '@/framework/base/components/EditCurrency.vue';
  import EditInfo from '@/framework/base/components/EditInfo.vue';
  import EditQuantity from '@/framework/base/components/EditQuantity.vue';
  import SelectField from '@/framework/base/components/SelectField.vue';
  import { SynthesePaie } from '@/generated/classes/Paie';
  import { FieldStatus } from '@/framework/base/components/FieldInfo';
  import { getCurrency } from '@/framework/base/helpers/Localization';
  import Etablissement from '@/generated/classes/Etablissement';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import {
    AppControls,
    AppButtons,
    AppCustoms,
    AppSections,
    FwkButtons,
    RessourceAppControl,
    RessourceAppButton,
    RessourceAppCustom,
    RessourceAppSection,
    RessourceFwkButton
  } from '@/ressources/globalRessources';
  import { Extended } from '@/framework/base/classes/Schema';
  import { defineComponent, type PropType } from "vue";
  import DateFieldMultiple from "@/framework/base/components/DateFieldMultiple.vue";

  export default defineComponent({
    name: 'SectionRemunerSectionRemunerationation',
    components: {
      LoaderButton,
      EditCurrency,
      EditInfo,
      EditQuantity,
      SelectField,
      SectionHeader,
      DateFieldMultiple
    },
    props: {
      hideTitle: {
        type: Boolean,
        required: false,
      },
      contrat: {
        type: Object as PropType<Contrat>,
        required: true,
      },
      paie: {
        type: Object as PropType<Paie>
      },
      dialog: {
        type: Boolean,
        required: false,
      },
      title: {
        type: String,
        required: false,
      },
      extended: {
        type: Boolean,
        required: false,
      },
    },
    data() {
      return {
        isMobile: isMobile(),
        contratId: 0,
        salarieBase: '',
        editValue: '',
        status: new FieldStatus(false, false, 0),
        montantStatus: new FieldStatus(false, false, 0),
        rubriqueBrutList: [] as Rubrique[],
        rubriqueNetList: [] as Rubrique[],
        toggleReset: false,
        calculDisabled: true,
        netEdit: false,
        brutEdit: false,
        employeurEdit: false,
        isCalculating: false,
        loading: false,
        listMonths: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
        modesAutres: ['Salaire BRUT total ', 'Salaire NET total', 'Coût employeur'],
        modesLabels: [] as string[],
        placeholder: 'Sélectionner',
        labelModes: 'Mode de calcul',
        choixPeriod: 'Période',
        selectedPeriod: null as Date | null,
        selectedVariableId: 0,
        quantite: '',
        dates: [] as string[],
        updatedVariableIndex: -1,
        showOnContract: false,
        modifyContrat: RessourceFwkButton(FwkButtons.MODIFIER).label,
      };
    },
    computed: {
      RessourceLabel(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_LABEL).label;
      },
      RessourceSalarie(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_SALARIE).label;
      },
      RessourceEmployeur(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_EMPLOYEUR).label;
      },
      RessourceQuantite(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_QUANTITE).label;
      },
      RessourceBase(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_BASE).label;
      },
      RessourceMontant(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_MONTANT).label;
      },
      RessourceSalaireBrut(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_SALAIRE_BRUT).label;
      },
      RessourceCotisationSalariale(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_COTISATION_SALARIALE).label;
      },
      RessourceCotisationPatronale(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_COTISATION_PATRONALE).label;
      },
      RessourceSalaireNet(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_SALAIRE_NET).label;
      },
      RessourcePrelevementSourcePaye(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_PRELEVEMENT_SOURCE_PAYE).label;
      },
      RessourcePrelevementSource(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_PRELEVEMENT_SOURCE).label;
      },
      RessourceSalaireNetDejaPaye(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_SALAIRE_NET_DEJA_PAYE).label;
      },
      RessourceSalaireNetAPayer(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_SALAIRE_NET_A_PAYER).label;
      },
      RessourceCoutEmployeur(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_COUT_EMPLOYEUR).label;
      },
      RessourceAPayer(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_A_PAYER).label;
      },
      RessourceFraisSansAbo(): any {
        return RessourceAppCustom(AppCustoms.REMUNERATION_FRAIS_SANS_ABO).label;
      },
      editPaie(): boolean {
        return this.paie != undefined;
      },
      canEdit(): boolean {
        if (this.editPaie) {
          return this.paie.statut < PaieStatuts.APPROVED;
        } else {
          return this.contrat.statut < ContratStatuts.SUBMITTED ||
            this.contrat.statut == ContratStatuts.MODIFIED;
        }
      },
      calculTaux(): boolean {
        return this.contrat.modeCalcul == ContratModeCalculs.TAUX
      },
      montantLabel(): string {
        if (this.contrat.modeCalcul == ContratModeCalculs.TAUX) {
          if (this.rubriquesBrut.length > 1) {
            return 'Montants unitaires';
          } else {
            return 'Montant unitaire';
          }
        } else {
          return 'Montant total';
        }
      },
      minimumLabel(): string {
        return 'Minimum légal';
      },
      listModes(): string[] {
        //this.modesLabels = []
        let cachets = false;
        let heures = false;
        this.rubriquesBrut.forEach((rubrique) => {
          if (rubrique.type == RubriqueTypes.HEURES) {
            heures = true;
          } else if (rubrique.type == RubriqueTypes.NOMBRE) {
            cachets = true;
          }
        })
        let tauxRubrique = '';
        if (cachets && heures) {
          tauxRubrique = 'Cachets et heures (BRUT)';
        } else if (cachets) {
          tauxRubrique = 'Cachets (BRUT)';
        } else if (heures) {
          tauxRubrique = 'Heures (BRUT)';
        }
        if (!this.modesLabels.includes(tauxRubrique) && tauxRubrique != '') {
          this.modesLabels.push(tauxRubrique);
        }
        this.modesAutres.forEach((item) => {
          if (!this.modesLabels.includes(item)) {
            this.modesLabels.push(item)
          }
        });
        return this.modesLabels;
      },
      calculMode: {
        get(): string {
          switch (this.contrat.modeCalcul) {
            case ContratModeCalculs.TAUX:
              return this.modesLabels.find(label => !this.modesAutres.includes(label)) ?? this.placeholder;
            case ContratModeCalculs.BRUT:
              return this.modesAutres[0];
            case ContratModeCalculs.NET:
              return this.modesAutres[1];
            case ContratModeCalculs.TOTAL:
              return this.modesAutres[2];
            default:
              return this.placeholder;
          }
        },
        set(value: string) {
          if (value == this.modesAutres[0]) {
            this.contrat.modeCalcul = ContratModeCalculs.BRUT;
          } else if (value == this.modesAutres[1]) {
            this.contrat.modeCalcul = ContratModeCalculs.NET;
          } else if (value == this.modesAutres[2]) {
            this.contrat.modeCalcul = ContratModeCalculs.TOTAL;
          } else if (this.modesLabels.includes(value)) {
            this.contrat.modeCalcul = ContratModeCalculs.TAUX;
          } else {
            this.contrat.modeCalcul = ContratModeCalculs.NONE;
          }
        },
      },
      dateFin(): Date {
        let dateFin: Date;
        if (this.contrat.dateFin != null) {
          dateFin = new Date(this.contrat.dateFin);
        } else {
          dateFin = new Date(this.contrat.dateDebut);
          dateFin.setFullYear(dateFin.getFullYear() + 1);
        }
        return dateFin;
      },
      periodSelected: {
        get(): string {
          if (this.selectedPeriod) {
            return this.getPeriodLabel(this.selectedPeriod);
          } else {
            return '';
          }
        },
        set(value: string) {
          const date = value.split(' ');
          const year = parseInt(date[1]);
          const month = this.listMonths.indexOf(date[0]);
          this.selectedPeriod = new Date(year, month, 15);
        },
      },
      listPeriods(): string[] {
        const res: string[] = [];
        if (this.paie) {
          res.push(this.getPeriodLabel(this.paie.dateFin));
        } else {
          const dateFin = new Date(this.contrat.dateDebut);
          const dateDebut = new Date(this.contrat.dateDebut);
          while (dateFin <= this.dateFin) {
            res.push(this.getPeriodLabel(dateFin));
            dateFin.setMonth(dateFin.getMonth() + 1);
          }
          if (this.dateFin.getDate() < dateDebut.getDate() &&
            this.dateFin.getMonth() - dateDebut.getMonth() > 1) {
            res.push(this.getPeriodLabel(this.dateFin));
          }
        }
        return res;
      },
      synthesePaies: {
        get(): SynthesePaie[] {
          if (this.contrat.id != this.contratId) {
            this.contratId = this.contrat.id;
            if (this.editPaie) {
              this.contrat.modeCalcul = ContratModeCalculs.TAUX;
            }
            if (this.contrat.modeCalcul == ContratModeCalculs.NONE) {
              this.calculMode = '';
            }
          }
          if (this.paie && this.paie.synthesePaie) {
            const synthesePaies: SynthesePaie[] = [];
            synthesePaies.push(this.paie.synthesePaie);
            return synthesePaies;
          } else {
            return this.contrat.synthesePaies;
          }
        },
        set(value: SynthesePaie[]) {
          if (this.editPaie) {
            this.paie.synthesePaie = value.length == 1 ? value[0] : new SynthesePaie();
          } else {
            this.contrat.synthesePaies = value;
          }
        },
      },
      rubriquesBrut(): Rubrique[] {
        this.rubriqueBrutList = [];
        if (this.editPaie) {
          this.paie.rubriques.forEach((rubriquePaie) => {
            const rubrique = storeRubrique.listRubrique.find(a => a.id == rubriquePaie.rubriqueId);
            if (rubrique && !this.rubriqueBrutList.includes(rubrique)) {
              this.rubriqueBrutList.push(rubrique);
            }
          })
        } else {
          this.contrat.rubriques.forEach((rubriquePaie) => {
            const rubrique = storeRubrique.listRubrique.find(a => a.id == rubriquePaie.rubriqueId);
            if (rubrique && !this.rubriqueBrutList.includes(rubrique)) {
              this.rubriqueBrutList.push(rubrique);
            }
          });
        }
        return this.rubriqueBrutList;
      },
      etablissement(): Etablissement {
        return storeEtablissement.getEtablissement(this.contrat.etablissementId);
      },
      fraisGestionLabel(): string {
        const fraisGestion = RessourceAppCustom(AppCustoms.REMUNERATION_FRAIS_GESTION).label;
        const bulletin = RessourceAppCustom(AppCustoms.REMUNERATION_BULLETIN).label;
        return fraisGestion + (this.synthesePaies.length > 1 ? ` (${this.synthesePaies.length} ${bulletin})` : '');
      },
      ressource(): any {
        if (this.editPaie) {
          return RessourceAppSection(AppSections.VARIABLE_PAIE);
        } else {
          return RessourceAppSection(AppSections.REMUNERATION);
        }
      },
      netAPayer(): number {
        let net = 0;
        this.synthesePaies.forEach(c => net += c.netAPayer);
        return net;
      },
      editNetAvantImpotVal(): number {
        let sum = 0;
        this.synthesePaies.forEach(c => sum += c.netAvantImpots - c.frais - c.acompte - c.avantageNet);
        return sum;
      },
      editNetAvantImpot: {
        get(): string {
          if (this.netEdit) {
            return this.editValue;
          } else {
            return this.editNetAvantImpotVal.toString();
          }
        },
        set(value: string) {
          this.netEdit = true;
          this.editValue = value;
          this.resetRemuneration(ContratModeCalculs.NET);
        },
      },
      chargeSalariale(): string {
        let sum = 0;
        this.synthesePaies.forEach(c => sum += c.cotisationsSalariales);
        return this.getCurrency(sum);
      },
      editBrutVal(): number {
        let sum = 0;
        this.synthesePaies.forEach(c => {
          if (c.brut) {
            sum += c.brut.montant;
          }
        });
        return sum;
      },
      editBrut: {
        get(): string {
          if (this.brutEdit) {
            return this.editValue;
          } else {
            return this.editBrutVal.toString();
          }
        },
        set(value: string) {
          this.brutEdit = true;
          this.editValue = value;
          this.resetRemuneration(ContratModeCalculs.BRUT);
        },
      },
      chargePatronales(): string {
        let sum = 0;
        this.synthesePaies.forEach(c => sum += c.cotisationsEmployeur);
        return this.getCurrency(sum);
      },
      coutTotal(): string {
        return this.getCurrency(this.coutTotalVal);
      },
      coutTotalVal(): number {
        let sum = 0;
        this.synthesePaies.forEach(c => sum += c.total);
        return sum;
      },
      fraisGestion(): string {
        let sum = 0;
        this.synthesePaies.forEach(c => sum += (c.traitement + c.dossier));
        // Applique arrondi comptable avant multiplication (cohérent avec serveur)
        const fraisHT = this.arrondiCompta(sum);
        const fraisTVA = this.arrondiCompta(sum * 0.2);
        const fraisTTC = this.arrondiCompta(fraisHT + fraisTVA);
        return this.getCurrency(fraisTTC);
      },
      editEmployeur: {
        get(): string {
          if (this.employeurEdit) {
            return this.editValue;
          } else {
            let sum = 0;
            this.synthesePaies.forEach(c => {
              if (c.coutEmployeur) {
                sum += c.coutEmployeur.montant;
              }
            });
            return sum.toString();
          }
        },
        set(value: string) {
          this.employeurEdit = true;
          this.editValue = value;
          this.resetRemuneration(ContratModeCalculs.TOTAL);
        },
      },
      calculLabel(): string {
        return RessourceAppButton(AppButtons.CALCULER).label;
      },
      montant(): string {
        let res = '';
        if (this.contrat.modeCalcul == ContratModeCalculs.BRUT) {
          res = this.editBrut;
        } else if (this.contrat.modeCalcul == ContratModeCalculs.NET) {
          res = this.editNetAvantImpot;
        } else if (this.contrat.modeCalcul == ContratModeCalculs.TOTAL) {
          res = this.editEmployeur;
        }
        return res;
      },
      addUpdateLabel(): string {
        if (this.updatedVariableIndex >= 0) {
          return RessourceFwkButton(FwkButtons.MODIFIER).label;
        } else {
          return RessourceFwkButton(FwkButtons.AJOUTER).label;
        }
      },
      variableNetIds(): number[] {
        const ids: number[] = [];
        const rubriques = storeRubrique.listRubrique.filter(a =>
          a.category == RubriqueCategorys.NET_AVANTAGE ||
          a.category == RubriqueCategorys.NET_FRAIS ||
          a.category == RubriqueCategorys.ACOMPTE_AVANCE);
        rubriques.forEach((item) => ids.push(item.id));
        return ids;
      },
      variableBrutIds(): number[] {
        const ids: number[] = [];
        const rubriques = storeRubrique.listRubrique.filter(a =>
          a.category == RubriqueCategorys.BRUT ||
          a.category == RubriqueCategorys.BRUT_AVANTAGE);
        rubriques.forEach((item) => ids.push(item.id));
        return ids;
      },
      variablesBrut(): VariablePaie[] {
        if (this.editPaie) {
          return this.paie.variables.filter(a => this.variableBrutIds.includes(a.rubriqueId));
        } else if (this.contrat.variables && this.contrat.variables.length > 0) {
          return this.contrat.variables.filter(a => this.variableBrutIds.includes(a.rubriqueId));
        } else {
          return [];
        }
      },
      variablesNet(): VariablePaie[] {
        if (this.editPaie) {
          return this.paie.variables.filter(a => this.variableNetIds.includes(a.rubriqueId));
        } else if (this.contrat.variables && this.contrat.variables.length > 0) {
          return this.contrat.variables.filter(a => this.variableNetIds.includes(a.rubriqueId));
        } else {
          return [];
        }
      },
      periode(): Period {
        return new Period(this.contrat.dateDebut.toString(), this.dateFin.toString());
      },
      selectEditFieldInfo(): FieldInfo {
        const ressource = RessourceAppControl(AppControls.RUBRIQUE_SELECT);
        const type = EditFieldType.SELECT;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(ressource, type, precision, mask, format, focus, live);
      },
      dateEditFieldInfo(): FieldInfo {
        const ressource = RessourceAppControl(AppControls.SALAIRE_DATE);
        const type = EditFieldType.DATE;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(ressource, type, precision, mask, format, focus, live);
      },
      rubriquesPaie(): { title: string, key: number }[] {
        const items: { title: string, key: number }[] = [];
        const rubriques = storeRubrique.listRubrique.filter(a =>
          a.category == RubriqueCategorys.NET_AVANTAGE ||
          a.category == RubriqueCategorys.NET_FRAIS ||
          a.category == RubriqueCategorys.ACOMPTE_AVANCE ||
          a.category == RubriqueCategorys.BRUT ||
          a.category == RubriqueCategorys.BRUT_AVANTAGE)
        rubriques.forEach(rubrique => {
          if (rubrique) {
            const label = rubrique.label;
            items.push(new Item(rubrique.id, label));
          }
        });
        return items;
      },
      variableDefined(): boolean {
        let res = false;
        if (this.selectedVariableId > 0) {
          const rubrique = storeRubrique.getRubrique(this.selectedVariableId);
          const quantite = parseFloat(this.quantite);
          res = this.selectedVariableId > 0 &&
            (this.listPeriods.length == 1 || this.selectedPeriod != null) &&
            ((rubrique.type == RubriqueTypes.DATE && this.dates.length > 0) ||
              ((rubrique.type == RubriqueTypes.NOMBRE || rubrique.type == RubriqueTypes.MONTANT) && quantite > 0))
        }
        return res;
      },
      canotModify(): boolean {
        return this.paie == undefined &&
          (this.contrat.statut == ContratStatuts.SUBMITTED ||
            this.contrat.statut == ContratStatuts.APPROUVED ||
            this.contrat.statut == ContratStatuts.SIGNED ||
            this.contrat.statut == ContratStatuts.CHECKED);
      }
    },
    created() {
      if (this.contrat.editBaseSalarie > 0) {
        this.editValue = getCurrency(this.contrat.editBaseSalarie);
      }
    },
    methods: {
      getMonth(value: Date): string {
        return this.listMonths[value.getMonth()];
      },
      getPeriodLabel(value: Date): string {
        const date = new Date(value)
        const label = this.getMonth(date) + ' ' + date.getFullYear().toString();
        return label;
      },
      arrondiCompta(value: number): number {
        // Implémente l'arrondi comptable AwayFromZero (équivalent de Math.Round C# avec MidpointRounding.AwayFromZero)
        // Arrondi à 2 décimales, avec 0.5 arrondi vers l'infini (positif/négatif)
        if (value >= 0) {
          return Math.round(value * 100 + 0.000001) / 100;
        } else {
          return Math.round(value * 100 - 0.000001) / 100;
        }
      },
      resetRemuneration(mode: ContratModeCalculs) {
        const montant = this.montant
        this.synthesePaies = [];
        this.calculDisabled = false;
        if (mode != ContratModeCalculs.NONE) {
          this.contrat.modeCalcul = mode;
        } else {
          this.setMontant(montant);
        }
      },
      // Prèlèvement à la source
      pasAPayer(): bool {
        return this.pasMontant() > 0;
      },
      pasMontant(): number {
        let sum = 0;
        this.synthesePaies.forEach(s => {
          sum += s.pas.montant;
        });        
        return sum;
      },      
      setMontant(value: string) {
        if (this.contrat.modeCalcul == ContratModeCalculs.BRUT) {
          this.editBrut = value;
        } else if (this.contrat.modeCalcul == ContratModeCalculs.NET) {
          this.editNetAvantImpot = value;
        } else if (this.contrat.modeCalcul == ContratModeCalculs.TOTAL) {
          this.editEmployeur = value;
        }
      },
      statusMontant(status: FieldStatus) {
        if (status.error) {
          this.calculDisabled = true;
        } else {
          this.calculDisabled = false;
        }
      },
      taux(value: number): string {
        return (value * 100).toFixed(2) + ' %'
      },
      currency(value: number): string {
        return this.getCurrency(value);
      },
      quantity(value: number, rubriqueId: number): string {
        const rubrique = storeRubrique.getRubrique(rubriqueId);
        if (rubrique.type == RubriqueTypes.HEURES) {
          return DateFormat.getQuantityHeuresMinutes(value);
        } else {
          return value.toFixed(2);
        }
      },
      rubriqueBase(rubriqueId: number): number {
        let res = 0;
        if (this.contrat.basesSalarie) {
          this.contrat.basesSalarie.forEach((base) => {
            if (base.rubriqueId == rubriqueId) {
              res = base.rbase;
            }
          });
        }
        return res;
      },
      rubriqueBaseFixed(rubriqueId: number): number | string {
        const amount = Number(this.rubriqueBase(rubriqueId).toFixed(2));
        return amount;
      },
      minimum(rubriqueId: number): string {
        let res = '';
        const rubrique = storeRubrique.getRubrique(rubriqueId);
        const label = rubrique.minLabel != null && rubrique.minLabel != '' ? rubrique.minLabel : rubrique.label
        if (this.contrat.basesSalarie) {
          this.contrat.basesSalarie.forEach((base) => {
            if (base.rubriqueId == rubriqueId) {
              res = base.minimum.toFixed(2) + ' € (' + label + ')';
            }
          });
        }
        return res;
      },
      rubriqueMontant(rubriqueId: number): number {
        return this.rubriqueBase(rubriqueId) * this.rubriqueQuantity(rubriqueId);
      },
      setRubriqueBase(value: string, rubriqueId: number) {
        let found = false;
        if (this.contrat.basesSalarie) {
          this.contrat.basesSalarie.forEach((base) => {
            if (base.rubriqueId == rubriqueId) {
              const amount = parseFloat(value);
              if (amount.toString() == value) {
                base.rbase = parseFloat(value);
              }
              found = true;
            }
          });
        }
        if (!found) {
          const baseSalarie = new BaseSalarie();
          baseSalarie.rbase = parseFloat(value);
          baseSalarie.rubriqueId = rubriqueId;
          if (this.contrat.basesSalarie) {
            this.contrat.basesSalarie.push(baseSalarie);
          }
          this.salarieBase = value;
        }
        this.editValue = '';
        this.resetRemuneration(ContratModeCalculs.TAUX);
      },
      getQuantity(value: number): string {
        return value.toFixed(2);
      },
      rubriqueQuantity(rubriqueId: number): number {
        let quantity = 0;
        if (this.editPaie) {
          const rubriquePaie = this.paie.rubriques.find(a => a.rubriqueId == rubriqueId);
          if (rubriquePaie) {
            quantity = rubriquePaie.quantite;
          }
        } else {
          const rubriques = this.contrat.rubriques.filter(a => a.rubriqueId == rubriqueId);
          rubriques.forEach((rubrique) => {
            quantity += rubrique.quantite;
          });
        }
        return quantity;
      },
      variableQuantity(variable: RubriquePaie): number {
        return 1;
      },
      variableBase(variable: RubriquePaie): number {
        return variable.quantite;
      },
      variableMontant(variable: RubriquePaie): number {
        let res = 0;
        if (variable.rubriqueId > 0) {
          const rubrique = storeRubrique.getRubrique(variable.rubriqueId);
          res = variable.quantite * (rubrique.negatif ? -1 : 1);
        }
        return res;
      },
      getVariableLabel(variable: RubriquePaie): string {
        let res = '';
        if (variable.rubriqueId > 0) {
          res = storeRubrique.getRubrique(variable.rubriqueId).label;
        }
        return res;
      },
      getRubriqueLabel(rubriqueId: number) {
        let res = '';
        if (rubriqueId > 0) {
          const rubrique = storeRubrique.getRubrique(rubriqueId);
          res = rubrique.label;
        }
        return res;
      },
      getRubrique(rubriqueId: number): Rubrique | undefined {
        return this.rubriqueBrutList.find((r) => r.id == rubriqueId);
      },
      calculMontant(a: number, b: number): string {
        return this.getCurrency(a * b);
      },
      getCurrency(value: number): string {
        if (typeof (value) == "number") {
          if (this.isMobile) {
            return value.toFixed(2);
          } else {
            return getCurrency(value);
          }
        } else {
          return value;
        }
      },
      closeDialog() {
        this.$emit('closeDialog');
      },
      resetDisplay() {
        this.toggleReset = !this.toggleReset;
      },
      setTaux() {
        this.toggleReset = !this.toggleReset;
      },
      selectVariable(variable: VariablePaie) {
        if (event != undefined) {
          event.stopPropagation();
        }
        if (this.canDelete(variable)) {
          if (this.editPaie && this.paie) {
            const index = this.paie.variables.findIndex(a =>
              a.rubriqueId == variable.rubriqueId &&
              a.quantite == variable.quantite);
            if (index != undefined && index >= 0) {
              const rubriqueId = this.paie.variables[index].rubriqueId;
              const item = this.rubriquesPaie.find(a => a.key == rubriqueId)
              if (item) {
                this.updatedVariableIndex = index;
                this.selectedVariableId = item.key;
                this.quantite = this.paie.variables[index].quantite.toString();
              }
            }
          } else {
            const index = this.contrat.variables.findIndex(a =>
              a.rubriqueId == variable.rubriqueId &&
              a.quantite == variable.quantite);
            if (index != undefined && index >= 0) {
              const rubriqueId = this.contrat.variables[index].rubriqueId;
              const item = this.rubriquesPaie.find(a => a.key == rubriqueId)
              if (item) {
                this.updatedVariableIndex = index;
                this.selectedVariableId = item.key;
                this.quantite = this.contrat.variables[index].quantite.toString();
                this.showOnContract = !!this.contrat.variables[index].showOnContract;
              }
            }
          }
        } else {
          this.unselectVariable();
        }
      },
      unselectVariable() {
        this.updatedVariableIndex = -1;
        this.showOnContract = false;
        this.selectedVariableId = 0;
        this.quantite = '';
      },
      deleteVariable(variable: VariablePaie) {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.unselectVariable();
        const index = this.contrat.variables.findIndex(a =>
          a.rubriqueId == variable.rubriqueId &&
          a.quantite == variable.quantite);
        if (index != undefined && index >= 0) {
          this.contrat.variables.splice(index, 1);
          this.resetRemuneration(ContratModeCalculs.NONE);
          this.calculDisabled = false;
        }
        if (this.editPaie) {
          const indexPaie = this.paie.variables.findIndex(a => a == variable);
          if (indexPaie != undefined && indexPaie >= 0) {
            this.paie.variables.splice(indexPaie, 1);
            this.calculDisabled = false;
          }
        }
      },
      getDisplayVariable(rubriqueId: number): string {
        const item = this.rubriquesPaie.find(a => a.key == rubriqueId)
        return item ? item.title : ''
      },
      setUpdatedVariable(item: Item) {
        this.selectedVariableId = item.key;
      },
      setVariableShowOnContract(variable: VariablePaie, value: boolean) {
        variable.showOnContract = !!value;
        if (this.updatedVariableIndex >= 0 && this.contrat.variables[this.updatedVariableIndex] === variable) {
          this.showOnContract = variable.showOnContract;
        }
        this.resetRemuneration(ContratModeCalculs.NONE);
      },
      setQuantite(value: string) {
        this.quantite = value;
      },
      setDate(value: string[]) {
        this.dates = [];
        value.forEach(v => {
          this.dates.push(DateFormat.toEdit(v));
        });
      },
      addUpdateVariablePaie(): void {
        if (isNaN(parseFloat(this.quantite))) {
          this.quantite = '0';
        }
        let variablePaie = new VariablePaie();
        let rubrique = new Rubrique();

        if (this.selectedVariableId > 0 && (!isNaN(parseFloat(this.quantite)) || this.dates.length > 0)) {
          if (this.updatedVariableIndex >= 0) {
            if (this.editPaie && this.paie) {
              variablePaie = this.paie.variables[this.updatedVariableIndex];
            } else {
              variablePaie = this.contrat.variables[this.updatedVariableIndex];
            }
            rubrique = storeRubrique.getRubrique(variablePaie.rubriqueId);
          } else {
            rubrique = storeRubrique.getRubrique(this.selectedVariableId);
            variablePaie.rubriqueId = this.selectedVariableId;
          }
          if (!this.editPaie) {
            variablePaie.showOnContract = this.showOnContract;
          }
          if (rubrique.type == RubriqueTypes.NOMBRE || rubrique.type == RubriqueTypes.MONTANT) {
            variablePaie.quantite = parseFloat(this.quantite);
          } else if (rubrique.type == RubriqueTypes.DATE) {
            //variablePaie.date = this.dates;
          }
          if (this.listPeriods.length > 1) {
            if (this.selectedPeriod) {
              variablePaie.date = new Date(this.selectedPeriod);
              this.selectedPeriod = null;
            }
          } else {
            if (this.paie) {
              variablePaie.date = new Date(this.paie.dateFin.getFullYear(), this.paie.dateFin.getMonth(), 15);
            } else {
              variablePaie.date = new Date(this.contrat.dateDebut.getFullYear(), this.contrat.dateDebut.getMonth(), 15);
            }
          }
          if (this.updatedVariableIndex < 0) {
            if (this.paie) {
              this.paie.variables.push(variablePaie);
            } else {
              this.contrat.variables.push(variablePaie);
            }
          }
          this.unselectVariable();
          this.dates = [];

        }
        this.resetRemuneration(ContratModeCalculs.NONE);
      },
      getRubriqueFromVariablePaie(variablePaie: RubriquePaie): Rubrique {
        return this.getRubriqueById(variablePaie.rubriqueId);
      },
      getRubriqueById(id: number): Rubrique {
        let res = new Rubrique();
        if (id > 0) {
          res = storeRubrique.getRubrique(id);
        }
        return res;
      },
      isVariableNombre(rubriqueId: number): boolean {
        if (rubriqueId > 0) {
          return this.getRubriqueById(rubriqueId).type == RubriqueTypes.NOMBRE;
        }
        return false;
      },
      isVariableMontant(rubriqueId: number): boolean {
        if (rubriqueId > 0) {
          return this.getRubriqueById(rubriqueId).type == RubriqueTypes.MONTANT;
        }
        return false;
      },
      isVariableDate(rubriqueId: number): boolean {
        if (rubriqueId > 0) {
          return this.getRubriqueById(rubriqueId).type == RubriqueTypes.DATE;
        }
        return false;
      },
      canDelete(variable: VariablePaie): boolean {
        const indexContrat = this.contrat.variables.findIndex(a =>
          a.rubriqueId == variable.rubriqueId &&
          a.quantite == variable.quantite);
        return (indexContrat == undefined || indexContrat < 0 || this.contrat.statut < ContratStatuts.APPROUVED)
      },
      checkFields(): boolean {
        let error = false;
        if (!error) {
          if (this.$refs['MONTANT']) {
            // @ts-expect-error : generated method
            if (this.$refs['MONTANT'].touch()) {
              error = true;
            }
          }
        }
        return error;
      },
      calculate() {
        if (!this.checkFields()) {
          this.contrat.editBaseSalarie = parseFloat(this.editValue);
          if (isNaN(this.contrat.editBaseSalarie)) {
            this.contrat.editBaseSalarie = 0;
          }
          this.isCalculating = true;
          if (this.editPaie) {
            Paie.calcul(this.paie).then((res: Paie) => {
              if (res.synthesePaie != null) {
                this.paie.synthesePaie = res.synthesePaie;
              }
              this.calculDisabled = true;
              this.isCalculating = false;
            }).catch(() => {
              if (this.paie.synthesePaie != null) {
                this.synthesePaies = [this.paie.synthesePaie];
              }
              this.calculDisabled = true;
              this.isCalculating = false;
            });
          } else {
            Contrat.calcul(this.contrat).then((res: Contrat) => {
              this.netEdit = false;
              this.brutEdit = false;
              this.employeurEdit = false;
              if (res.synthesePaies != null) {
                this.synthesePaies = res.synthesePaies;
              }
              this.contrat.synthesePaies = res.synthesePaies;
              this.contrat.basesSalarie = res.basesSalarie;
              if (res.synthesePaies && res.synthesePaies.length > 0) {
                this.status.error = false;
                this.status.updated = true;
                this.status.objId = this.contrat.id
                this.$emit('status', this.status);
                this.calculDisabled = true;
              } else {
                this.calculDisabled = false;
              }
              this.isCalculating = false;
            }).catch(() => {
              if (this.contrat.synthesePaies != null) {
                this.synthesePaies = this.contrat.synthesePaies;
              }
              this.isCalculating = false;
            });
          }
        }
      },
      setExtended(extended: Extended): void {
        this.$emit('extended', extended);
      },
      modify(): void {
        this.loading = true;
        Contrat.modify(this.contrat).then(() => {
          this.loading = false;
          this.$emit('updated');
        }).catch(() => {
          this.loading = false;
        });
      },
    },
  });
</script>

<style scoped>
  ::v-deep .remuneration-table div.v-input {
    padding: 0 !important;
  }

  .synthese {
    border-bottom: solid 1px !important;
  }

  tbody td, ::v-deep .edit-link .v-text-field input {
    color: #707070 !important;
  }
</style>
